export const VISIBLE_ADDITIONAL_INFO = [
  'alternative_parcel_id',
  'delivery_person',
  'locker_number',
  'additional_info',
  'driver_name',
  'shipper_name',
  'post_office',
  'hub_location',
  'expected_delivery_date',
  'location',
  'place_of_delivery',
  'reason',
  'awb_number',
  'courier_name',
  'note',
  'comments',
  'recipient_name',
  'follow_up_action',
  'phone_number',
  'country_code',
  'destination_country',
  'next_location',
  'carrier_name',
  'destination',
  'origin',
  'recipient',
  'delivery_date_time',
];

export const TRACKING_EVENT_ANALYTICS = {
  regular: 'regular',
  exception: 'exception',
  delay: 'delay',
};
